<template>
  <div class="dashboard-widget">
    <h6 class="text-primary">Latest Tour Bookings</h6>
    <BookingItem
      v-for="booking in bookingsByType('tour')"
      :key="'tour-' + booking.id"
      :booking="booking"
    />

    <h6 class="text-primary">Latest Event Bookings</h6>
    <BookingItem
      v-for="booking in bookingsByType('event')"
      :key="'event-' + booking.id"
      :booking="booking"
    />
  </div>
</template>

<script>
import bookingApi from "@/services/api/booking";
import BookingItem from "./BookingItem.vue";

export default {
  name: "WidgetNewBookings",

  components: { BookingItem },

  data() {
    return {
      bookings: []
    };
  },

  computed: {
    bookingsByType() {
      return (type, limit = 5) =>
        this.bookings.filter(b => b.type?.value === type).slice(0, limit);
    }
  },

  created() {
    bookingApi.getNewBookings().then(response => {
      this.bookings = response.data.bookings;
    });
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";

h6 {
  margin: 0.5rem 0;
}

p {
  margin: 0;
}
</style>
